import { LanguagePack } from '../../translations';
import enLanguagePack from "../../translations/lang_en";
import ruLanguagePack from "../../translations/lang_ru";

declare var __DEFAULT_LOCALE__: string;
const defaultLocale = __DEFAULT_LOCALE__;

export interface LanguageOption
{
    code: string;
    display: string;
}

export const languagePacks = new Map<string, LanguagePack>([
    ['en', enLanguagePack],
    ['ru', ruLanguagePack],
]);

export const getPrefLocale = () => {
    const languages: string[] = (navigator as any).languages || [navigator.language || (navigator as any).userLanguage];
    return languages.map(l => l.substr(0, 2).toLowerCase()).find(locale => languagePacks.has(locale)) || defaultLocale;    
}

export const getLanguageOptions = (): LanguageOption[] => {
    return Array.from(languagePacks).map(kvp => ({ code: kvp[0], display: kvp[1]['lang'] }));
}


// WEBPACK FOOTER //
// ./src/polyglot/languagePacks.ts